import sat from 'sat';
import _ from 'common/customLodash';

class Helper {
    getImage(imageUrl) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = err => reject(err);
            img.crossOrigin = 'Anonymous';
            img.src = imageUrl;
        });
    }

    getAngle(firstPos, secondPos) {
        const xDistance = firstPos.x - secondPos.x;
        const yDistance = firstPos.y - secondPos.y;
        const rad = Math.atan2(yDistance, xDistance);
        return rad * (180 / Math.PI);
    }

    isIntersecting(rect1, rect2) {
        const createVector = corner => {
            return new sat.Vector(corner.x, corner.y);
        };
        const createPolygon = rect => {
            return new sat.Polygon(new sat.Vector(), [
                createVector(rect.topLeft),
                createVector(rect.bottomLeft),
                createVector(rect.bottomRight),
                createVector(rect.topRight)
            ]);
        };

        const p1 = createPolygon(rect1);
        const p2 = createPolygon(rect2);

        return sat.testPolygonPolygon(p1, p2);
    }

    getCorners(konvaObj) {
        const size = {
            width: konvaObj.getWidth(),
            height: konvaObj.getHeight()
        };
        const corners = {
            topLeft: {x: 0, y: 0},
            topRight: {x: size.width, y: 0},
            bottomLeft: {x: 0, y: size.height},
            bottomRight: {x: size.width, y: size.height}
        };
        const transform = konvaObj.getAbsoluteTransform();
        const tCorners = _.mapValues(corners, c => transform.point(c));

        return tCorners;
    }

    getConstrainedSize(box, maxSize) {
        const maxWidth = maxSize.width;
        const maxHeight =  maxSize.height;
        const boxSize = {width: box.width, height: box.height};

        const widthOverflow = boxSize.width - maxWidth;
        if (widthOverflow > 0) {
            boxSize.height = maxWidth / boxSize.width * boxSize.height;
            boxSize.width = maxWidth;
        }

        const heightOverflow = boxSize.height - maxHeight;
        if (heightOverflow > 0) {
            boxSize.width = maxHeight / boxSize.height * boxSize.width;
            boxSize.height = maxHeight;
        }

        return boxSize;
    }
}

export default new Helper();



// WEBPACK FOOTER //
// ./src/common/helper.js